import { render, staticRenderFns } from "./BulkProjectViewPage.vue?vue&type=template&id=fa134676&scoped=true&"
import script from "./BulkProjectViewPage.vue?vue&type=script&lang=ts&"
export * from "./BulkProjectViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./BulkProjectViewPage.vue?vue&type=style&index=0&id=fa134676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa134676",
  null
  
)

export default component.exports